// extracted by mini-css-extract-plugin
module.exports = {"simulatorInput":"MoneyInput_simulatorInput__iM_Qw","input":"MoneyInput_input__I85oI"};